<template>
  <div>
    <!-- Filters -->
    <v-row class="mb-4">
      <v-col cols="12" md="2">
        <label style="font-size: 12px">data inicio:</label>
        <v-text-field v-model="dtinicio" type="date" dense hide-details></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <label style="font-size: 12px">data Fim:</label>
        <v-text-field v-model="dtfinal" type="date" dense hide-details></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <label style="font-size: 12px">Notas:</label>
        <v-select
          v-model="nota_filtro"
          item-title="text"
          item-value="value"
          :items="notaItems"
          dense
          hide-details
        ></v-select>
      </v-col>

      <v-col cols="12" md="2">
        <label style="font-size: 12px">Loja:</label>
        <v-select
          item-title="text"
          item-value="value"
          v-model="origem_loja_filtro"
          :items="lojaItems"
          dense
          hide-details
        ></v-select>
      </v-col>

      <v-col cols="12" md="2">
        <label style="font-size: 12px">Status:</label>
        <v-select
          item-title="text"
          item-value="value"
          v-model="status_filtro"
          :items="statusItems"
          dense
          hide-details
        ></v-select>
      </v-col>

      <v-col cols="12" md="2" class="d-flex flex-column">
        <label style="font-size: 12px">Merece Atenção:</label>
        <v-select
          item-title="text"
          item-value="value"
          v-model="merece_atencao_filtro"
          :items="mereceItems"
          dense
          hide-details
        ></v-select>
      </v-col>

      <v-col cols="12" md="8">
        <label style="font-size: 12px">Pesquisa:</label>
        <v-text-field v-model="pesquisar" dense hide-details></v-text-field>
      </v-col>

      <v-col cols="12" md="2" class="d-flex align-end ga-2">
        <v-btn color="primary" @click="buscar" :loading="loading">
          <v-icon left>mdi-magnify</v-icon>
          Pesquisar
        </v-btn>

        <v-btn color="" @click="clear" :loading="loading">
          <v-icon left>mdi-close</v-icon>
        </v-btn>

        <v-btn color="secondary" @click="abrirCadastro">
          <v-icon left>mdi-plus</v-icon>
          Cadastrar
        </v-btn>
      </v-col>
    </v-row>

    <!-- Create / Edit Dialog -->
    <v-dialog v-model="dialogForm" max-width="700" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">
          {{ editandoId ? 'Editar Avaliação' : 'Cadastrar Avaliação' }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <v-form ref="formRef">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.pedido_id"
                  label="Pedido ID *"
                  type="number"
                  :rules="[rules.required]"
                  variant="outlined"
                  dense
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.star_avaliacao"
                  label="Nota (estrelas) *"
                  :items="[1, 2, 3, 4, 5]"
                  :rules="[rules.required]"
                  variant="outlined"
                  dense
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.telefone_cliente"
                  label="Telefone do cliente *"
                  v-mask="'(##) #####-####'"
                  :rules="[rules.required]"
                  variant="outlined"
                  dense
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.data_avaliacao"
                  label="Data da avaliação *"
                  type="datetime-local"
                  :rules="[rules.required]"
                  variant="outlined"
                  dense
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.texto_avaliacao"
                  label="Texto da avaliação *"
                  :rules="[rules.required]"
                  variant="outlined"
                  rows="3"
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.link_avaliacao"
                  label="Link da avaliação *"
                  :rules="[rules.required]"
                  variant="outlined"
                  dense
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.observacao_tmkt"
                  label="Observação TMKT *"
                  :rules="[rules.required]"
                  variant="outlined"
                  rows="3"
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="form.origem_loja"
                  label="Loja de origem"
                  :items="lojaItems"
                  item-title="text"
                  item-value="value"
                  variant="outlined"
                  dense
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="form.status"
                  label="Status"
                  :items="statusItems"
                  item-title="text"
                  item-value="value"
                  variant="outlined"
                  dense
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="form.merece_atencao"
                  label="Merece Atenção"
                  :items="mereceItems"
                  item-title="text"
                  item-value="value"
                  variant="outlined"
                  dense
                  hide-details="auto"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4 justify-end">
          <v-btn variant="text" @click="fecharDialogForm" :disabled="apiCrud.loading.value"
            >Cancelar</v-btn
          >
          <v-btn color="primary" @click="salvar" :loading="apiCrud.loading.value">
            {{ editandoId ? 'Salvar' : 'Cadastrar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="dialogDelete" max-width="420" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">Confirmar exclusão</v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          Tem certeza que deseja excluir este registro? Esta ação não pode ser desfeita.
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4 justify-end">
          <v-btn variant="text" @click="dialogDelete = false" :disabled="apiCrud.loading.value"
            >Cancelar</v-btn
          >
          <v-btn color="red" @click="confirmarDelete" :loading="apiCrud.loading.value"
            >Excluir</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Table (horizontal scroll) -->
    <div style="overflow-x: auto">
      <v-data-table
        style="min-width: 1200px"
        :headers="headers"
        :items="items"
        :loading="loading"
        :items-per-page="itemsPerPage"
        class="elevation-1"
        disable-pagination
      >
        <template #item.link="{ item }">
          <span style="font-size: 12px">
            {{ item.link }}
            <v-btn
              v-if="item.link && item.link.includes('https')"
              icon
              small
              @click="onAction(item)"
            >
              <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </span>
        </template>

        <template #item.status="{ item }">
          <!-- NAO_RESOLVIDO -->

          <v-chip
            :color="
              item.status === 'RESOLVIDO'
                ? 'blue'
                : item.status === 'NAO_RESOLVIDO'
                  ? 'red'
                  : 'grey'
            "
            small
            dark
          >
            {{
              item.status === 'RESOLVIDO'
                ? 'RESOLVIDO'
                : item.status === 'NAO_RESOLVIDO'
                  ? 'NÃO RESOLVIDO'
                  : '-'
            }}
          </v-chip>
        </template>

        <template #item.telefone="{ item }">
          <div style="min-width: 120px">
            {{ item.telefone }}
          </div>
        </template>

        <template #item.data="{ item }">
          {{ item.data }}
        </template>

        <template #item.acoes="{ item }">
          <!-- editar -->
          <v-btn icon small style="margin-bottom: 0.5rem" @click="abrirEdicao(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <!-- deletar -->
          <v-btn icon small color="red" @click="abrirDelete(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>

        <template #item.texto="{ item }">
          <div
            style="
              width: 360px;
              white-space: pre-wrap;
              word-break: break-word;
              overflow-wrap: anywhere;
            "
          >
            {{ item.texto }}
          </div>
        </template>

        <template #item.observacao="{ item }">
          <div
            style="
              width: 360px;
              white-space: pre-wrap;
              word-break: break-word;
              overflow-wrap: anywhere;
            "
          >
            {{ item.observacao }}
          </div>
        </template>

        <template #bottom>
          <div class="d-flex justify-space-between align-center px-4 py-2">
            <div class="d-flex align-center">
              <span class="text-caption text-secondary mr-4">
                Total de {{ items.length }} item{{ (items.length || 0) > 1 ? 's' : '' }}
              </span>

              <v-select
                v-model="itemsPerPage"
                :items="[10, 25, 50, 100]"
                label="Itens por página"
                @update:model-value="
                  (perPage) => {
                    itemsPerPage = perPage
                    onPerPageChange()
                  }
                "
                variant="outlined"
                dense
                hide-details
                style="width: 140px"
              />
            </div>

            <v-pagination
              v-if="totalPages > 1"
              :model-value="page"
              :length="totalPages"
              :total-visible="5"
              @update:model-value="
                (newPage) => {
                  page = newPage
                  onPageChange()
                }
              "
              rounded
              class="my-2"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useApi } from '@/utils/axios'
import { POS_VENDA_AVALIACAO_ROTAS } from '@/utils/apiRoutes'
import { formatToDateTimeBR } from '@/utils/date'
import { useNotificationStore } from '@/stores/notification'

const notificationStore = useNotificationStore()

const apiList = useApi(POS_VENDA_AVALIACAO_ROTAS.LISTAR_POS_VENDA_AVALIACAO)
const apiCrud = useApi(POS_VENDA_AVALIACAO_ROTAS.LISTAR_POS_VENDA_AVALIACAO)

const dtinicio = ref('')
const dtfinal = ref('')
const nota_filtro = ref('')
const origem_loja_filtro = ref('')
const status_filtro = ref('')
const merece_atencao_filtro = ref('')
const pesquisar = ref('')

const page = ref(1)
const itemsPerPage = ref(10)
const total = ref(0)
const items = ref([])
const loading = apiList.loading

// --- Dialog state ---
const dialogForm = ref(false)
const dialogDelete = ref(false)
const editandoId = ref(null)
const deletandoId = ref(null)
const formRef = ref(null)

const formVazio = () => ({
  pedido_id: null,
  star_avaliacao: null,
  telefone_cliente: '',
  data_avaliacao: '',
  texto_avaliacao: '',
  link_avaliacao: '',
  observacao_tmkt: '',
  origem_loja: '',
  status: '',
  merece_atencao: '',
})
const form = ref(formVazio())

const rules = {
  required: (v) => (v !== null && v !== undefined && v !== '') || 'Campo obrigatório',
}

// headers must use Vuetify shape { text, value }
const headers = [
  { title: 'Atendente', value: 'atendente' },
  { title: 'Status', value: 'status', sortable: true },
  { title: 'Link', value: 'link' },
  { title: 'Pedido', value: 'pedido', sortable: true },
  { title: 'Telefone', value: 'telefone' },
  { title: 'Data', value: 'data', sortable: true },
  { title: 'Loja', value: 'loja', sortable: true },
  { title: 'Texto', value: 'texto' },
  { title: 'Nota', value: 'nota', sortable: true },
  { title: 'Merece Atenção', value: 'merece' },
  { title: 'Observação', value: 'observacao' },
  { title: 'Criado', value: 'criado' },
  { title: 'Ações', value: 'acoes', sortable: false },
]

const notaItems = [
  { text: 'Todas', value: '' },
  { text: '1 Estrela', value: '1' },
  { text: '2 Estrelas', value: '2' },
  { text: '3 Estrelas', value: '3' },
  { text: '4 Estrelas', value: '4' },
  { text: '5 Estrelas', value: '5' },
  { text: '2 ou menos', value: '-2' },
  { text: '3 ou menos', value: '-3' },
  { text: '4 ou menos', value: '-4' },
  { text: '5 ou menos', value: '-5' },
]

const lojaItems = [
  { text: 'Todos', value: '' },
  { text: 'Play Store', value: 'GOOGLE' },
  { text: 'Apple', value: 'APPLE' },
]

const statusItems = [
  { text: 'Todos', value: '' },
  { text: 'Não resolvido', value: 'NAO_RESOLVIDO' },
  { text: 'Resolvido', value: 'RESOLVIDO' },
]

const mereceItems = [
  { text: 'Todos', value: '' },
  { text: 'Sim', value: 'SIM' },
  { text: 'Não', value: 'NAO' },
]

const totalPages = computed(() => {
  return Math.max(1, Math.ceil((total.value || 0) / itemsPerPage.value))
})

function clear() {
  dtinicio.value = ''
  dtfinal.value = ''
  nota_filtro.value = ''
  origem_loja_filtro.value = ''
  status_filtro.value = ''
  merece_atencao_filtro.value = ''
  pesquisar.value = ''
  page.value = 1
  itemsPerPage.value = 10

  items.value = []
  total.value = 0
}

async function buscar() {
  const params = {
    dtinicio: dtinicio.value || undefined,
    dtfinal: dtfinal.value || undefined,
    nota_filtro: nota_filtro.value || undefined,
    origem_loja: origem_loja_filtro.value || undefined,
    status: status_filtro.value || undefined,
    merece_atencao: merece_atencao_filtro.value || undefined,
    pesquisar: pesquisar.value || undefined,
    page: page.value || 1,
    perPage: itemsPerPage.value,
  }

  try {
    const res = await apiList.fetch({ params })
    const raw = res?.data || []
    items.value = raw.map((r) => ({
      id: r.id,
      atendente: r?.atendente?.nome || r.atendente_id || null,
      link: r.link_avaliacao ?? r.link ?? '',
      pedido: r.pedido_id ?? null,
      telefone: r.telefone_cliente ?? r.telefone ?? '',
      data: r.data_avaliacao ? formatToDateTimeBR(r.data_avaliacao) : '',
      loja: r.origem_loja ?? '',
      texto: r.texto_avaliacao ?? r.texto ?? '',
      nota: r.star_avaliacao ?? r.nota ?? null,
      status: r.status ?? '',
      merece: r.merece_atencao ?? r.merece ?? '',
      observacao: r.observacao_tmkt ?? r.observacao ?? '',
      criado: r.created_at ? formatToDateTimeBR(r.created_at) : '',
      // raw fields for edit pre-fill
      _raw: r,
    }))
    total.value = res?.meta?.total ?? res?.total ?? items.value.length
  } catch (e) {
    // error handled by useApi.error
  }
}

function onPageChange() {
  buscar()
}

function onPerPageChange() {
  page.value = 1
  buscar()
}

function onAction(item) {
  window.open(item.link || '#', '_blank')
}

// --- CRUD helpers ---
function abrirCadastro() {
  editandoId.value = null
  form.value = formVazio()
  dialogForm.value = true
}

function abrirEdicao(item) {
  editandoId.value = item.id
  const r = item._raw || {}
  form.value = {
    pedido_id: r.pedido_id ?? item.pedido ?? null,
    star_avaliacao: r.star_avaliacao ?? item.nota ?? null,
    telefone_cliente: r.telefone_cliente ?? item.telefone ?? '',
    data_avaliacao: r.data_avaliacao ? r.data_avaliacao.slice(0, 16) : '',
    texto_avaliacao: r.texto_avaliacao ?? item.texto ?? '',
    link_avaliacao: r.link_avaliacao ?? item.link ?? '',
    observacao_tmkt: r.observacao_tmkt ?? item.observacao ?? '',
    origem_loja: r.origem_loja ?? item.loja ?? '',
    status: r.status ?? item.status ?? '',
    merece_atencao: r.merece_atencao ?? item.merece ?? '',
  }
  dialogForm.value = true
}

function fecharDialogForm() {
  dialogForm.value = false
  formRef.value?.reset()
}

async function salvar() {
  const { valid } = await formRef.value.validate()
  if (!valid) return

  const payload = {
    pedido_id: Number(form.value.pedido_id),
    star_avaliacao: Number(form.value.star_avaliacao),
    telefone_cliente: form.value.telefone_cliente,
    data_avaliacao: form.value.data_avaliacao,
    texto_avaliacao: form.value.texto_avaliacao,
    link_avaliacao: form.value.link_avaliacao,
    observacao_tmkt: form.value.observacao_tmkt,
    origem_loja: form.value.origem_loja || undefined,
    status: form.value.status || undefined,
    merece_atencao: form.value.merece_atencao || undefined,
  }

  try {
    if (editandoId.value) {
      await apiCrud.put(payload, editandoId.value)
      notificationStore.showNotification('Avaliação atualizada com sucesso', 'success')
    } else {
      await apiCrud.post(payload)
      notificationStore.showNotification('Avaliação cadastrada com sucesso', 'success')
    }
    fecharDialogForm()
    buscar()
  } catch (e) {
    const msg =
      e?.response?.data?.message ||
      e?.response?.data?.error ||
      (editandoId.value ? 'Erro ao atualizar avaliação' : 'Erro ao cadastrar avaliação')
    notificationStore.showNotification(msg, 'error')
  }
}

function abrirDelete(item) {
  deletandoId.value = item.id
  dialogDelete.value = true
}

async function confirmarDelete() {
  try {
    await apiCrud.del(deletandoId.value)
    notificationStore.showNotification('Avaliação excluída com sucesso', 'success')
    dialogDelete.value = false
    deletandoId.value = null
    buscar()
  } catch (e) {
    const msg =
      e?.response?.data?.message || e?.response?.data?.error || 'Erro ao excluir avaliação'
    notificationStore.showNotification(msg, 'error')
  }
}
</script>
